/**
 * Configuration des statuts et actions pour les opérations
 * Basé sur les fichiers statusBDC.json et statusMS.json
 */

import { StatusActionMap } from './types';

// ============================================================================
// Mapping des actions pour les Marchés Subséquents (MS)
// Les IDs correspondent au fichier statusMS.json
// ============================================================================
// ID 1:  Brouillon
// ID 2:  Consultation en cours
// ID 3:  À candidater
// ID 4:  À analyser
// ID 5:  En attente de l'analyse
// ID 6:  Refuser
// ID 7:  À signer (Acheteur)
// ID 8:  En attente de signature (Prestataire)
// ID 9:  En attente de signature (Acheteur)
// ID 10: À signer (Prestataire)
// ID 11: Valider
// ID 12: Expirer
// ID 13: À notifier

export const STATUS_ACTION_MAP_MS: StatusActionMap = {
  1: {
    buttonText: 'À reprendre',
    action: 'reprendre',
    forRoles: ['Admin', 'Acheteur', 'Acheteur admin'],
    requiresAction: false
  },
  2: {
    buttonText: '',
    action: '',
    forRoles: [],
    requiresAction: false
  },
  3: {
    buttonText: '',
    action: '',
    forRoles: [],
    requiresAction: false
  },
  4: {
    buttonText: 'À analyser',
    action: 'analyser',
    forRoles: ['Acheteur', 'Acheteur admin', 'Admin'],
    requiresAction: true
  },
  5: {
    buttonText: '',
    action: '',
    forRoles: [],
    requiresAction: true
  },
  6: {
    buttonText: '',
    action: '',
    forRoles: [],
    requiresAction: false
  },
  7: {
    buttonText: 'À signer',
    action: 'signer',
    forRoles: ['Acheteur', 'Acheteur signataire', 'Acheteur signataire admin', 'Admin'],
    requiresAction: true
  },
  8: {
    buttonText: '',
    action: '',
    forRoles: [],
    requiresAction: false
  },
  9: {
    buttonText: 'Relancer',
    action: 'relancer',
    forRoles: ['Acheteur signataire', 'Acheteur signataire admin', 'Admin'],
    requiresAction: false
  },
  10: {
    buttonText: '',
    action: '',
    forRoles: [],
    requiresAction: false
  },
  11: {
    buttonText: 'PDF',
    action: 'download',
    forRoles: ['Acheteur', 'Acheteur signataire', 'Acheteur signataire admin', 'Acheteur admin', 'Admin'],
    requiresAction: false
  },
  12: {
    buttonText: '',
    action: '',
    forRoles: [],
    requiresAction: false
  },
  13: {
    buttonText: '',
    action: '',
    forRoles: [],
    requiresAction: false
  }
};

// ============================================================================
// Mapping des actions pour les Bons de Commande (BC)
// Les IDs correspondent au fichier statusBDC.json
// ============================================================================
// ID 1:  Brouillon acheteur
// ID 2:  Brouillon prestataire
// ID 3:  En attente de l'acceptation du rang 1
// ID 4:  À accepter
// ID 5:  En attente de l'acceptation du rang 2
// ID 6:  En attente de l'acceptation du rang 3
// ID 7:  Validé
// ID 8:  Refusé
// ID 9:  Expiré
// ID 10: En attente de l'offre
// ID 11: À chiffrer
// ID 12: À analyser
// ID 13: En attente de l'analyse
// ID 15: En attente de décision de l'acheteur

export const STATUS_ACTION_MAP_BC: StatusActionMap = {
  1: {
    buttonText: 'À reprendre',
    action: 'reprendre',
    forRoles: ['Acheteur', 'Acheteur signataire', 'Acheteur admin', 'Acheteur signataire admin', 'Admin'],
    requiresAction: false
  },
  4: {
    buttonText: 'À accepter',
    action: 'accepter',
    forRoles: ['Acheteur', 'Acheteur signataire', 'Acheteur admin', 'Acheteur signataire admin', 'Admin'],
    requiresAction: true
  },
  7: {
    buttonText: 'PDF',
    action: 'download',
    forRoles: ['Acheteur', 'Acheteur signataire', 'Acheteur signataire admin', 'Acheteur admin', 'Admin'],
    requiresAction: false
  },
  11: {
    buttonText: 'À chiffrer',
    action: '',
    forRoles: ['Acheteur', 'Acheteur signataire', 'Acheteur admin', 'Acheteur signataire admin', 'Admin'],
    requiresAction: true
  },
  12: {
    buttonText: 'À analyser',
    action: 'analyser',
    forRoles: ['Acheteur', 'Acheteur signataire', 'Acheteur admin', 'Acheteur signataire admin', 'Admin'],
    requiresAction: true
  },
  13: {
    buttonText: "En attente de l'analyse",
    action: '',
    forRoles: ['Acheteur', 'Acheteur signataire', 'Acheteur admin', 'Acheteur signataire admin', 'Admin'],
    requiresAction: true
  },
  17: {
    buttonText: 'À signature',
    action: '',
    forRoles: ['Acheteur', 'Acheteur signataire', 'Acheteur admin', 'Acheteur signataire admin', 'Admin'],
    requiresAction: true
  }
};

// ============================================================================
// Mapping des actions pour les Bons de Commande Importés (BCI)
// ============================================================================

export const STATUS_ACTION_MAP_BCI: StatusActionMap = {
  4: {
    buttonText: 'À accepter',
    action: 'analyser',
    forRoles: ['Prestataire', 'Prestataire admin', 'Admin'],
    requiresAction: true
  },
  7: {
    buttonText: 'PDF',
    action: 'download',
    forRoles: ['Acheteur', 'Acheteur signataire', 'Acheteur signataire admin', 'Acheteur admin', 'Admin'],
    requiresAction: false
  }
};

// ============================================================================
// Configuration des onglets
// ============================================================================

export const TABS = [
  'Tous',
  'Action requise',
  'En attente',
  'Brouillons',
  'Accepté',
  'Refusé / Expiré',
  'Archive',
  'Paniers importés'
] as const;

export type TabName = typeof TABS[number];

// ============================================================================
// Mapping entre les onglets et les filtres API
// ============================================================================

export interface TabMapping {
  filter: string;
  statusIds: number[];
}

export const TAB_TO_STATUS_MAPPING: Record<number, TabMapping> = {
  0: { filter: '', statusIds: [] }, // Tous
  1: { filter: 'status_action=1', statusIds: [] }, // Action requise
  2: { filter: 'status_type_compte=Acheteur&&status_action=0', statusIds: [] }, // En attente
  3: { filter: 'status_id=1', statusIds: [1] }, // Brouillons
  4: { filter: 'status_id=11', statusIds: [11] }, // Accepté (Validé)
  5: { filter: 'status_id=6,12', statusIds: [6, 12] }, // Refusé / Expiré
  6: { filter: 'accepté', statusIds: [] }, // Archive
  7: { filter: '', statusIds: [] } // Paniers importés
};

// ============================================================================
// Options de type pour le filtre
// ============================================================================

export const TYPE_OPTIONS = [
  { label: 'Tous', value: 'Tous' },
  { label: 'Bon de Commande', value: 'BC' },
  { label: 'Marché Subséquent', value: 'MS' }
] as const;
